export const makeValidPhoneNumber = (phoneNumber: string | null): string | null => {
    if (typeof phoneNumber === 'string' && phoneNumber.trim() === '') {
        return null;
    }
    return phoneNumber;
};
